import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useApiClient from '~/src/hooks/useApiClient';
import { snackbarMessageSelector } from '~/src/Snackbar/store';
import { pendingCreateFolderState, Folder, folderNameState, currentFolderState } from '../store';
import useFind from '~/src/Projects/hooks/useFind';

const useCreateFolder = () => {
  const { t } = useTranslation('folders');
  const apiClient = useApiClient();
  const setPending = useSetRecoilState(pendingCreateFolderState);
  const setSnackbarMessage = useSetRecoilState(snackbarMessageSelector);
  const displayName = useRecoilValue(folderNameState);
  const currentFolder = useRecoilValue(currentFolderState);
  const [find] = useFind();

  const createFolder = async () => {
    try {
      setPending(true);
      await apiClient.post<Folder>('/folders', {
        displayName: displayName.trim(),
        parentFolderId: currentFolder?._id ?? null,
      });
      // Refresh the current folder view to show the new subfolder
      setTimeout(() => {
        find();
      }, 100);
    } catch (err) {
      setSnackbarMessage({
        message: t('errors.createFolder'),
        severity: 'error',
      });
    } finally {
      setPending(false);
    }
  };

  return [createFolder];
};

export default useCreateFolder;
